import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=f566c564&"
import script from "./AuthDialog.vue?vue&type=script&lang=js&"
export * from "./AuthDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AuthDialog.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports